import * as actionTypes from '../actions/actionTypes';

export default function (state = null, action) {
  switch (action.type) {
    case actionTypes.FETCH_IRA_ACCOUNT_SUCCESS:
      return action.iraAccount;
    default:
      return state;
  }
}
